import React, { useMemo } from 'react';

import Text from '~/components/core/TextComponents/Text';

export function parseClaimNumbers(raw: string): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const token of raw.split(/[,\n]/)) {
    const trimmed = token.trim();
    if (trimmed && !seen.has(trimmed)) {
      seen.add(trimmed);
      result.push(trimmed);
    }
  }
  return result;
}

interface ClaimNumbersInputStepProps {
  claimNumbers: string;
  onClaimNumbersChange: (value: string) => void;
}

const ClaimNumbersInputStep: React.FC<ClaimNumbersInputStepProps> = ({ claimNumbers, onClaimNumbersChange }) => {
  const parsedCount = useMemo(() => parseClaimNumbers(claimNumbers).length, [claimNumbers]);

  return (
    <div className="flex w-full flex-col gap-12">
      <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.SEMI_BOLD}>
        Enter Claim Numbers
      </Text>
      <Text variant={Text.VARIANTS.XS} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
        Paste claim numbers separated by commas or new lines.
      </Text>
      <textarea
        className="border-gray-300 font-mono min-h-[200px] w-full rounded border p-12 text-sm"
        placeholder={'CLM-001\nCLM-002\nCLM-003'}
        value={claimNumbers}
        onChange={(e) => onClaimNumbersChange(e.target.value)}
      />
      <Text variant={Text.VARIANTS.XS} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
        {parsedCount} claim number{parsedCount !== 1 ? 's' : ''} entered
      </Text>
    </div>
  );
};

export default ClaimNumbersInputStep;
